/*
  Policy links that open in a modal without giving up the link.

  The three reassurance items on a product page are the shipping, warranty and
  returns links. Each one is a real anchor with a real href, so a crawler — and
  Merchant Center, which reads these pages — follows it to the policy page, and
  so does a reader with JavaScript off. This element intercepts the click and
  opens the policy in the same `modal-dialog` the size-guide popup uses.

  Progressive enhancement, in both directions: no script, no matching dialog,
  or a dialog that has not upgraded yet, and the click falls through to plain
  navigation. Nothing is preventDefault-ed until there is something to show.

  Dawn's own `modal-opener` cannot do this job — it binds to a <button> and
  ignores anchors, so the link would either not open the modal or not be a
  link.
*/
if (!customElements.get('policy-modal-opener')) {
  customElements.define(
    'policy-modal-opener',
    class PolicyModalOpener extends HTMLElement {
      constructor() {
        super();
        this.link = this.querySelector('a[href]');
        if (!this.link) return;
        this.link.addEventListener('click', this.onClick.bind(this));
      }

      onClick(event) {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;

        const selector = this.getAttribute('data-modal');
        if (!selector) return;

        const modal = document.querySelector(selector);
        if (!modal || typeof modal.show !== 'function') return;

        event.preventDefault();
        modal.show(this.link);
      }
    }
  );
}
